module.exports = __webpack_public_path__ + "img/invitation-to-register-for-owner-portal-en.2b5067f.png";